import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { ResourceCard } from './ResourceCard';

import {
  CLAIMS,
  INSURANCE,
} from '../../navigation/routes.constants';

import './Resources.css';
import { DownloadModal } from '../../common/DownloadModal';
import { getTelusDocs } from '../../../actions';
import { useUserBrands } from '../../../hooks';

const Resources = () => {
  const { t } = useTranslation('home');
  const history = useHistory();
  const dispatch = useDispatch();
  const [downLoadModalVisible, setDownLoadModalVisible] = useState(false);
  const store = useSelector(({
    personalInformation,
  }) => ({
    personalInformation,
  }), shallowEqual);

  const { hasPolicyPPU, showLiveVetSection } = useUserBrands();

  const { telusLink } = store.personalInformation;

  const onFileAClaimCick = () => {
    history.push(CLAIMS);
  };

  const onViewMyInsuranceCick = () => {
    history.push(INSURANCE);
  };

  const onDownloadAppCick = () => {
    setDownLoadModalVisible(true);
  };

  const onCloseDownloadModal = () => {
    setDownLoadModalVisible(false);
  };

  const onTelusDocsClick = () => {
    if (telusLink) {
      window.open(telusLink, '_blank');
    }
  };

  useEffect(() => {
    if (!hasPolicyPPU || telusLink) {
      return;
    }

    dispatch(getTelusDocs());
  }, [dispatch, hasPolicyPPU, telusLink]);

  return (
    <div className="Resources-main-container">
      <h1 className="Resources-title">
        {t('resources.title')}
      </h1>

      <DownloadModal
        onClose={onCloseDownloadModal}
        show={downLoadModalVisible}
      />

      <div className="Resources-card-container">
        <ResourceCard
          buttonLabel={t('resources.cards.fileAClaim.buttonLabel')}
          description={t('resources.cards.fileAClaim.description')}
          onClick={onFileAClaimCick}
          title={t('resources.cards.fileAClaim.title')}
        />

        <ResourceCard
          buttonLabel={t('resources.cards.'
            + 'viewMyInsurance.buttonLabel')}
          description={t('resources.cards.'
            + 'viewMyInsurance.description')}
          onClick={onViewMyInsuranceCick}
          title={t('resources.cards.'
            + 'viewMyInsurance.title')}
        />

        {showLiveVetSection && (
          <ResourceCard
            buttonLabel={t('resources.cards.downloadApp.buttonLabel')}
            description={t('resources.cards.downloadApp.description')}
            onClick={onDownloadAppCick}
            title={t('resources.cards.downloadApp.title')}
          />
        )}

        {hasPolicyPPU && telusLink && (
          <ResourceCard
            buttonLabel={t('resources.cards.telusDocs.buttonLabel')}
            description={t('resources.cards.telusDocs.description')}
            onClick={onTelusDocsClick}
            title={t('resources.cards.telusDocs.title')}
          />
        )}
      </div>
    </div>
  );
};

export { Resources };
